module.exports = __webpack_public_path__ + "img/engineering__landscape.aa3cdfd5.svg";